import React from "react";
import StepCard from "./StepCard";

const ordinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

const ThreadGroup = ({
    groupIndex,
    threadSubject,
    onThreadSubjectChange,
    groupSteps,         // [{ step, flatIndex }]
    globalStepNumber,   // { flatIndex: stepNumber }
    totalFlatSteps,
    canRemove,
    onRemoveThread,
    onAddStep,
    onUpdateStep,
    onRemoveStep,
    onMoveUp,
    onMoveDown,
}) => {
    return (
        <div className={`crm-thread-group${groupIndex === 0 ? " crm-thread-group--first" : ""}`}>
            {/* Header: thread label + subject input */}
            <div className="crm-thread-group__header">
                <span className="crm-thread-group__label">{ordinal(groupIndex + 1)} Thread</span>
                <input
                    className="admin-crm-subject crm-thread-group__subject"
                    placeholder="Email subject…"
                    value={threadSubject}
                    onChange={(e) => onThreadSubjectChange(e.target.value)}
                />
                {canRemove && (
                    <button
                        className="crm-thread-group__remove"
                        onClick={onRemoveThread}
                        title="Remove thread (steps merge into previous thread)"
                        type="button"
                    >
                        ✕
                    </button>
                )}
            </div>
            
            {/* Steps */}
            <div className="crm-thread-group__body">
                {groupSteps.length === 0 ? (
                    <div className="crm-thread-group__empty">
                        No steps yet — add an email or delay below.
                    </div>
                ) : (
                    <div className="crm-sequence-timeline">
                        {groupSteps.map(({ step, flatIndex }, localIndex) => (
                            <StepCard
                                key={flatIndex}
                                step={step}
                                index={flatIndex}
                                stepNumber={globalStepNumber[flatIndex]}
                                canMoveUp={flatIndex > 0}
                                canMoveDown={flatIndex < totalFlatSteps - 1}
                                showConnector={localIndex < groupSteps.length - 1}
                                onChange={onUpdateStep}
                                onRemove={onRemoveStep}
                                onMoveUp={onMoveUp}
                                onMoveDown={onMoveDown}
                            />
                        ))}
                    </div>
                )}
            </div>

            {/* Footer: add step buttons */}
            <div className="crm-thread-group__footer">
                <button className="admin-btn admin-btn--primary" onClick={() => onAddStep("email")} type="button">
                    + Email Step
                </button>
                <button className="admin-btn" onClick={() => onAddStep("delay")} type="button">
                    + Delay
                </button>
            </div>
        </div>
    );
};

export default ThreadGroup;
